/*-----------------------------------------------------------------
- Studio fields
-----------------------------------------------------------------*/
export default {
    action: 'عملیات',
};
